import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentAccess } from '../../../../../common/decorators/component-access.decorator';
import { CommonRoute } from '../../../../../common/enums/common-route.enum';
import { AuthenticationService } from '../../../../../common/services/authentication/authentication.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Subscription } from 'rxjs'; // Import Subscription
import { finalize } from 'rxjs/operators'; // Import finalize

@Component({
  selector: 'app-logout',
  standalone: true,
  templateUrl: './logout.component.html',
  imports: [ProgressSpinnerModule],
})
@ComponentAccess('LogoutComponent')
export class LogoutComponent implements OnInit, OnDestroy {
  private authenticationService = inject(AuthenticationService);
  private readonly router = inject(Router);

  readonly isLoading = signal<boolean>(true);
  private logoutSubscription?: Subscription;

  ngOnInit(): void {
    this.isLoading.set(true);
    // Perform logout and navigate ONLY after completion
    this.logoutSubscription = this.authenticationService
      .logout()
      .pipe(
        finalize(() => {
          this.isLoading.set(false);
        }),
      )
      .subscribe({
        next: () => {
          this.router.navigate([CommonRoute.LOGIN]);
        },
      });
  }

  // Optional: Unsubscribe on component destruction to prevent memory leaks
  ngOnDestroy(): void {
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
  }
}
